import { Toast } from "primereact/toast";
import { useContext, useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { EmployeePaystubListColumns, PayRollListColumns } from "../../appconfig/DatatableSetting";
import {
  getAllDetails,
  getPdfMergeResponse,
  getSpecificDetails,
  getSpecificItemDetails,
  getThreeDetailsByIdParam,
  getThreeDetailsParam,
  getTwoFilteredDetails,
  postAllData,
} from "../../service/ProductService";
import { GET_LIST_EMPLOYEE, INVOICE_PRINT, PAY_CYCLE_BY_CLIENT_ID, SAVE_EMPLOYEE_WITH_HOUR } from "../../config/ApiConstant";
import { createdAtTemplate, employeeNameTemplate, payPeriodTemplate, salaryTemplate } from "../../appconfig/TemplateFieldSetting";
import { useNavigate, useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { formatDate } from "../../appconfig/AppHelper";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import { MultiSelect } from "primereact/multiselect";

const PayrollReports = () => {
  document.title = "PayStub | Nexawage Payroll";
  const toast = useRef<any>(null);
  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const navigate = useNavigate();
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState<any>([]);
  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);

  const [employeeListFilter, setEmployeeListFilter] = useState<any[]>([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<Number | null>(null);
  const [payCycleOptions, setPayCycleOptions] = useState<any[]>([]);
  const [selectedPayCycleId, setSelectedPayCycleId] = useState<any>(null);

  const [printLoading, setPrintLoading] = useState<any>(false);

  const userRole = userData?.roles?.role_name || "";

  const { id }: any = useParams();
  // const user_id = atob(id);
  const client_id = id
    ? (() => {
      try {
        return atob(id);
      } catch {
        return null;
      }
    })()
    : null;

  // based on user logedin table column selection
  let payrollCol = userRole === "Employee" ? EmployeePaystubListColumns : PayRollListColumns;

  // useefect for get user list
  useEffect(() => {
    getListEmployee();

    if (userRole === "Client" || userRole === "User") {
      getAllEmployees();
      if (selectedYear) {
        fetchPayCycle();
      }
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [userData?.id]);

  useEffect(() => {
    if (userRole === "Client" || userRole === "User") {
      if (selectedEmployeeId === null && selectedPayCycleId === null) {
        getListEmployee();
        fetchPayCycle();
      } else if (!window.cn(selectedPayCycleId) || !window.cn(selectedEmployeeId)) {
        getListEmployee();
        fetchPayCycle();
      }
    }
  }, [selectedEmployeeId, selectedPayCycleId, selectedYear]);

  // on paycycle change
  const onCycleChangeSelect = (val: any) => {
    setSelectedPayCycleId(val);
  };

  // list-employee
  const getListEmployee = async () => {
    try {
      let empIdToSend = null;
      let clientIdToSend = null;

      if (userRole === "Employee") {
        empIdToSend = userData?.id;
      } else if (userRole === "Client") {
        empIdToSend = selectedEmployeeId;
        clientIdToSend = userData?.id;
      } else {
        clientIdToSend = client_id;
        empIdToSend = selectedEmployeeId;
      }

      const response = await getAllDetails(
        `${SAVE_EMPLOYEE_WITH_HOUR}?id=${clientIdToSend}&pay_cycle_id=${JSON.stringify(
          selectedPayCycleId,
        )}&emp_id=${empIdToSend}&year=${selectedYear}`,
      );

      const data = response;
      if (data) {
        setEmployeeList(data || []);
        setPageLoad(true);
      } else {
        setEmployeeList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // api to fetch paycycle
  const fetchPayCycle = async () => {
    try {
      let clientIdToSend = null;
      if (userRole === "Client") {
        clientIdToSend = userData?.id;
      } else if (userRole === "User") {
        clientIdToSend = client_id;
      }

      const response = await getTwoFilteredDetails(PAY_CYCLE_BY_CLIENT_ID, "id", clientIdToSend, "year", selectedYear);

      const data = response.payCycleList;

      const cycles = data.map((cycle: any) => ({
        label: `${formatDate(cycle.starting_date)} - ${formatDate(cycle.ending_date)}`,
        value: cycle.id,
      }));

      setPayCycleOptions(cycles || []);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // api call to get all employee
  const getAllEmployees = async () => {
    try {
      let clientIdToSend = null;
      if (userRole === "Client") {
        clientIdToSend = userData?.id;
      } else if (userRole === "User") {
        clientIdToSend = client_id;
      }

      const response = await getSpecificDetails(GET_LIST_EMPLOYEE, clientIdToSend);
      const users = response?.map((user: any) => ({
        label: `${user.first_name} ${user.last_name}`,
        value: user.id,
      }));

      setEmployeeListFilter(users);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // clear all filter
  const clearAll = () => {
    setGlobalFilter(null);
    setGlobalFieldFilter(null);
    setSelectedEmployeeId(null);
    setSelectedPayCycleId(null);
    setSelectedYear(currentYear);
  };

  // on year change
  const onYearChange = (e: any) => {
    const year = moment(e.value).year();
    if (year) setSelectedYear(year);
    setSelectedPayCycleId(null);
    setSelectedEmployeeId(null);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      <Calendar
        value={moment(String(selectedYear), "YYYY").toDate()}
        view="year"
        dateFormat="yy"
        onChange={(e: any) => onYearChange(e)}
        showIcon
        placeholder="Select Year"
        className="ml-2 w-11rem mr-3"
      />
      {userRole !== "Employee" && (
        <>
          <MultiSelect
            value={selectedPayCycleId}
            onChange={(e) => onCycleChangeSelect(e.value)}
            options={payCycleOptions}
            optionLabel="label"
            placeholder="Select Pay Cycles"
            maxSelectedLabels={3}
            className="mr-3 w-15rem"
          />

          <Dropdown
            value={selectedEmployeeId}
            onChange={(e) => setSelectedEmployeeId(e.value)}
            options={employeeListFilter}
            placeholder="Filter by Employee"
            className="w-15rem"
          />
        </>
      )}
    </>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <div className="payrollreport-template">
        {userRole !== "Employee" && (
          <>
            <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="mr-2 p-button-outlined common-p-outline-button" />
          </>
        )}
      </div>

      {userRole !== "Employee" && (
        <Button
          icon="pi pi-print"
          label="Print"
          className="  ml-2 common-primary-button"
          loading={printLoading}
          onClick={() => invoicePrint()}
          disabled={(selectedEmployeeId || selectedPayCycleId) && employeeList.length !== 0 ? false : true}
        />
      )}
    </>
  );

  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData.paystub_url) {
      window.open(rowData.paystub_url, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "PDF NOT FOUND",
      });
    }
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="View PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );

  // print paystub merged
  const invoicePrint = async () => {
    setPrintLoading(true);

    try {
      //Get Employee Name or Paystub Cycle for Pdf name
      let mergeFileNameTitle: any;
      if (selectedPayCycleId !== null && selectedEmployeeId !== null) {
        const optionSelected = employeeListFilter.find((p) => p.value === selectedEmployeeId);
        mergeFileNameTitle = optionSelected?.label;
      } else {
        if (selectedPayCycleId !== null) {
          if (Array.isArray(selectedPayCycleId)) {
            const selectedCycles = payCycleOptions.filter((p) => selectedPayCycleId.includes(p.value));

            mergeFileNameTitle = selectedCycles.map((c) => c.label).join(", ");
          } else {
            const optionSelected = payCycleOptions.find((p) => p.value === selectedPayCycleId);
            mergeFileNameTitle = optionSelected?.label;
          }
        }
        if (selectedEmployeeId !== null) {
          const optionSelected = employeeListFilter.find((p) => p.value === selectedEmployeeId);
          mergeFileNameTitle = optionSelected?.label;
        }
      }
      const response = await getPdfMergeResponse(
        INVOICE_PRINT,
        "id",
        selectedEmployeeId,
        "pay_cycle_id",
        JSON.stringify(selectedPayCycleId),
        "year",
        selectedYear,
      );
      //Response Check And open pdf merged
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Paystub Generated Successfully",
        });
        setPrintLoading(false);
        setSelectedPayCycleId(null);
        setSelectedEmployeeId(null);
        getListEmployee();
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // open in new tab with custom title
        const newTab: any = window.open();
        newTab.document.body.style.margin = "0";
        newTab.document.body.innerHTML = `
        <html>
        <head>
        <title>${mergeFileNameTitle}</title>
        <meta>
        </head>
        <iframe
          src="${pdfUrl}"
          width="100%"
          height="100%"
          style="border:none;"
        ></iframe></html>
      `;
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data.message,
      });
      setPrintLoading(false);
    }
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Payroll Reports" pageName="Pay Stub List" pageTitle="Pay Stub List" goToPage={userRole === "User"} />
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />
            {pageLoad ? (
              <DataTable
                value={employeeList}
                showGridlines
                responsiveLayout={"scroll"}
                dataKey="id"
                stripedRows
                globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={employeeList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " PayStub"}
                emptyMessage="No Pay Stub Data Found"
                filters={globalFieldFilter}
                onFilter={(e) => setGlobalFieldFilter(e.filters)}
                removableSort
              >
                {payrollCol.map((col, i) => {
                  if (col.field === "createdAt") {
                    return <Column key={col.field} field={col.field} header={col.header} body={createdAtTemplate} />;
                  } else if (col.field === "paystub_url") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else if (col.field === "pay_period") {
                    return <Column key={col.field} field={col.field} header={col.header} body={payPeriodTemplate} />;
                  } else if (col.field === "selection") {
                    return <Column key={col.field} field={col.field} header={col.header} selectionMode="multiple" />;
                  } else if (col.field === "user_id") {
                    return <Column key={col.field} field={col.field} header={col.header} body={employeeNameTemplate} />;
                  }
                  else if (col.field === "is_salary") {
                    return <Column key={col.field} field={col.field} header={col.header} body={salaryTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {payrollCol.map((col) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>
    </>
  );
};
export default PayrollReports;
